export default "__VITE_ASSET__NXpFa$OK__"